<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container m-5">
    <div class="vx-row">

      <h2 style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{ $t('Profit') }} </h2>
      <vs-input v-model="courseRequestBudgetModel.Profit" @change="CalculateTotal()" name="Name"
        style="padding-right:20px;padding-left:20px;padding-top:20px;" />

    </div>
    <vx-card class="flex-1 " :title="$t('InstructorServices')" style="margin-top:15px">

      <div class="vx-row">

        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ $t('InstructorFee') }} </p>
        <vs-input class="md:w-1/5 w-full " :label="$t('FeePerDay')" @change="CalculateTotal()"
          v-model="courseRequestBudgetModel.InstructorDailyRate" name="Name"
          style="padding-right:20px;padding-left:20px" />
        <vs-input class="md:w-1/5 w-full " :label="$t('OfDays')" @change="CalculateTotal()"
          v-model="courseRequestBudgetModel.NumOfCourseDays" name="Name" style="padding-right:20px;padding-left:20px" />
        <vs-input class="md:w-1/5 w-full " :label="$t('OfCourses')" @change="CalculateTotal()" v-model="NumberOFCourse"
          :disabled="true" name="Name" style="padding-right:20px;padding-left:20px" />

        <div class="vx-col">
          <label style="padding-right:20px;padding-top:20px;">{{ $t('SubTotal') }}</label>
          <h3 style="padding-right:20px;padding-top:20px;">
            {{ courseRequestBudgetModel.InstructorDailyRate * courseRequestBudgetModel.NumOfCourseDays }}</h3>
        </div>

      </div>

      <div class="vx-row">

        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ $t('InstructorFeeReport') }} </p>

        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"
          v-model="courseRequestBudgetModel.PreparationAndReport" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"
          v-model="courseRequestBudgetModel.PreparationAndReportDays" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" name="Name" :disabled="true"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ courseRequestBudgetModel.PreparationAndReport * courseRequestBudgetModel.PreparationAndReportDays }}</h3>
      </div>

      <div class="vx-row">

        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ $t('DailySubsistence') }} </p>

        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"
          v-model="courseRequestBudgetModel.DailySubsistenceAllowance" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"
          v-model="courseRequestBudgetModel.DailySubsistenceAllowanceDays" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="NumberOFCourse" name="Name"
          :disabled="true" style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ courseRequestBudgetModel.DailySubsistenceAllowance * courseRequestBudgetModel.DailySubsistenceAllowanceDays }}
        </h3>
      </div>
      <div class="vx-row">

        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{ $t('DSAweekends') }}
        </p>
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('FeePerDay')"
          v-model="courseRequestBudgetModel.DSAWeekend" name="Name" style="padding-right:20px;padding-left:20px" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('OfDays')"
          v-model="courseRequestBudgetModel.DSAWeekendDays" name="Name" style="padding-right:20px;padding-left:20px" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :disabled="true" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ courseRequestBudgetModel.DSAWeekend * courseRequestBudgetModel.DSAWeekendDays }}</h3>
      </div>

      <h1>{{ $t('ClassRoom') }}</h1>
      <div class="vx-row">
        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ $t('ClassRoomFees') }} </p>
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('FeePerDay')"
          v-model="courseRequestBudgetModel.ClassroomOperating" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('OfDays')"
          v-model="courseRequestBudgetModel.ClassroomDays" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" disabled="true" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ courseRequestBudgetModel.ClassroomDays * courseRequestBudgetModel.ClassroomOperating }}</h3>
      </div>

      <h1 class="mt-5">{{ $t('Travel') }}</h1>

      <div class="vx-row">

        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{ $t('AirTicket') }}
        </p>
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('CostPerTicket')"
          v-model="courseRequestBudgetModel.CostOfTicket" name="Name" style="padding-right:20px;padding-left:20px" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :disabled="true" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('OfTickets')"
          v-model="courseRequestBudgetModel.NumOfTicket" name="Name" style="padding-right:20px;padding-left:20px" />
        <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ courseRequestBudgetModel.NumOfTicket * courseRequestBudgetModel.CostOfTicket }}</h3>
      </div>

      <div class="vx-row">
        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ $t('TerminalAllowance') }} </p>
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="courseRequestBudgetModel.TerminalAllowance"
          name="Name" style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" name="Name" :disabled="true"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="courseRequestBudgetModel.NumOfAllowance"
          name="Name" style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ courseRequestBudgetModel.TerminalAllowance * courseRequestBudgetModel.NumOfAllowance }}</h3>
      </div>

    </vx-card>

    <vx-card class="flex-1 " :title="$t('TrainingFees')" style="margin-top:15px">

      <div class="vx-row">

        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;"> {{ $t('CourseFees') }}
        </p>
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('FeePerTrainee')"
          v-model="courseRequestBudgetModel.CourseFees" name="Name" style="padding-right:20px;padding-left:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :disabled="true" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :label="$t('OfTrainee')"
          v-model="courseRequestBudgetModel.NumOfTrainee" name="Name" style="padding-right:20px;padding-left:20px" />
        <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ courseRequestBudgetModel.NumOfTrainee * courseRequestBudgetModel.CourseFees }}</h3>

      </div>



      <div class="vx-row">
        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ $t('TabletOrHandout') }} </p>
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="courseRequestBudgetModel.TabletOrHandout"
          name="Name" style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :disabled="true" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"
          v-model="courseRequestBudgetModel.NumOfTabletOrHandout" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ courseRequestBudgetModel.NumOfTabletOrHandout * courseRequestBudgetModel.TabletOrHandout }}</h3>

      </div>
      <div class="vx-row">

        <p class="md:w-1/5 w-full " style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ $t('Transportation') }} </p>
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" v-model="courseRequestBudgetModel.Transportation"
          name="Name" style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()" :disabled="true" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <vs-input class="md:w-1/5 w-full " @change="CalculateTotal()"
          v-model="courseRequestBudgetModel.NumOfTransportation" name="Name"
          style="padding-right:20px;padding-left:20px;padding-top:20px;" />
        <h3 style="padding-right:20px;padding-left:20px;padding-top:20px;">
          {{ courseRequestBudgetModel.NumOfTransportation * courseRequestBudgetModel.Transportation }}</h3>

      </div>

    </vx-card>

    <div class="vx-row mt-5 ml-5" v-if="!courseRequestBudgetModel.CourseRequest.CourseID">
      <vs-input class="md:w-1/5 w-full" v-model="courseRequestBudgetModel.CourseHours" name="CourseHours"
        :label="$t('CourseHours')" />
      <div class="md:w-1/4 w-full ml-5">
        <a v-if="courseRequestBudgetModel.CourseProfilePath" :href="baseUrl + courseRequestBudgetModel.CourseProfilePath"
          download target="_blank">
          <feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" /></a>
        <label>{{ $t('CourseProfile') }} </label>
        <vs-upload label="Course Profile " automatic :limit="1" :action="uploadUrl" :headers="UploadRequestHeader"
          @on-success="successUpload" />
      </div>
    </div>

    <div class="flex flex-wrap-reverse items-center flex-grow justify-between">
      <div>
        <vs-button class="mr-6 mt-10"
          :disabled="!(courseRequestBudgetModel.NumOfTrainee > 0) || !(courseRequestBudgetModel.CourseFees > 0)"
          @click="submitData(false)">{{ $t('Submit') }}</vs-button>
        <vs-button class="mr-6 mt-10"
          :disabled="!(courseRequestBudgetModel.NumOfTrainee > 0) || !(courseRequestBudgetModel.CourseFees > 0)"
          @click="submitData(true)">{{ $t('SubmitSendPorposal') }} </vs-button>
        <vs-button class="mr-6 mt-10" @click="ViewPorposal">{{ $t('ViewPorposal') }} </vs-button>
        <vs-button type="border" class="mt-10" color="danger" @click="cancle">{{ $t('Cancel') }}</vs-button>
      </div>
      <div class="vx-row">
        <vs-input v-model="feesParTrainee" :disabled="true" name="Name" :label="$t('CoursePerTrainee')"
          style="padding-right:20px;padding-left:20px;padding-top:20px;color: red;font-weight: bold;font-size: 20px;" />
        <vs-input v-model="totalFees" :disabled="true" name="total" :label="$t('Total')"
          style="padding-right:20px;padding-left:20px;padding-top:20px;color: red;font-weight: bold;font-size: 20px;" />
      </div>
    </div>
  </div>
</template>


<script>

import moduleCourseRequest from "@/store/courseRequest/moduleCourseRequest.js";
import { domain, mainSetting } from '@/gloabelConstant.js';
export default {
  components: {

  },
  data() {
    return {
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      uploadUrl: domain + "API/Course/UploadFile",
      totalFees: 0,
      feesParTrainee: 0,
      NumberOFCourse: 1,
      courseRequestBudgetModel: {},
      baseUrl: domain,
    };
  },
  computed: {

  },

  methods: {
    successUpload(event) {
      debugger;
      this.courseRequestBudgetModel.CourseProfilePath = event.target.responseText;
      this.$vs.notify({
        fixed: true, color: 'success',
        title: 'Upload Success',
        text: this.$t("SuccessuploadyourAttachment")
      })
    },
    ViewPorposal() {
      window.open('#/Report/FinancialPorposal/' + this.$route.params.ID + "/" + this.totalFees + "/" + this.courseRequestBudgetModel.NumOfTrainee + "/" + this.courseRequestBudgetModel.CourseHours, '_blank');
    },

    CalculateTotal() {
      this.totalFees = 0;
      this.totalFees += this.courseRequestBudgetModel.InstructorDailyRate * this.courseRequestBudgetModel.NumOfCourseDays;
      this.totalFees += this.courseRequestBudgetModel.PreparationAndReport * this.courseRequestBudgetModel.PreparationAndReportDays;
      this.totalFees += this.courseRequestBudgetModel.DailySubsistenceAllowance * this.courseRequestBudgetModel.DailySubsistenceAllowanceDays;
      this.totalFees += this.courseRequestBudgetModel.DSAWeekend * this.courseRequestBudgetModel.DSAWeekendDays;
      this.totalFees += this.courseRequestBudgetModel.ClassroomDays * this.courseRequestBudgetModel.ClassroomOperating;
      this.totalFees += this.courseRequestBudgetModel.NumOfTicket * this.courseRequestBudgetModel.CostOfTicket;
      this.totalFees += this.courseRequestBudgetModel.TerminalAllowance * this.courseRequestBudgetModel.NumOfAllowance;
      this.totalFees += this.courseRequestBudgetModel.NumOfTrainee * this.courseRequestBudgetModel.CourseFees;
      this.totalFees += this.courseRequestBudgetModel.NumOfTabletOrHandout * this.courseRequestBudgetModel.TabletOrHandout;
      this.totalFees += this.courseRequestBudgetModel.NumOfTransportation * this.courseRequestBudgetModel.Transportation;
      if (this.courseRequestBudgetModel.Profit == undefined) {
        this.courseRequestBudgetModel.Profit = 0;
      }

      this.totalFees = this.totalFees + (this.totalFees * this.courseRequestBudgetModel.Profit) / 100;
      this.feesParTrainee = this.totalFees / this.courseRequestBudgetModel.NumOfTrainee;
    },

    notifyAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text
      });
    },
    cancle() {
      this.$router.push('/CourseRequest');
    },
    submitData(sendMail) {
      this.courseRequestBudgetModel.totalFees = this.totalFees;
      this.courseRequestBudgetModel.feesParTrainee = this.feesParTrainee;
      this.courseRequestBudgetModel.SendMail = sendMail;
      this.$vs.loading();
      this.$store.dispatch("courseRequestList/SetBudgetOfCourseRequest", this.courseRequestBudgetModel).then((res) => {
        this.$vs.loading.close();
        this.notifyAlert("success", this.$t("Done"), this.$t("CourseFeeChargedToParticipantis") + " " + res.data + " " + "USD");
        this.$router.push('/CourseRequest');
      }).catch(() => {
        this.$vs.loading.close();
      })

    },

  },

  created() {
    if (!moduleCourseRequest.isRegistered) {
      this.$store.registerModule("courseRequestList", moduleCourseRequest);
      moduleCourseRequest.isRegistered = true;
    }
    if (this.$route.params.ID != undefined) {
      debugger
      this.$vs.loading();
      this.$store.dispatch("courseRequestList/GetCourseRequestBudget", this.$route.params.ID)
        .then(res => {
          debugger
          this.$vs.loading.close();
          this.courseRequestBudgetModel = res.data
          if (this.courseRequestBudgetModel.NumOfTrainee == undefined || this.courseRequestBudgetModel.NumOfTrainee <= 0) {
            if (this.courseRequestBudgetModel.CourseRequest.NoOfTrainee > 0)
              this.courseRequestBudgetModel.NumOfTrainee = this.courseRequestBudgetModel.CourseRequest.NoOfTrainee;
            else
              this.courseRequestBudgetModel.NumOfTrainee = 1;
          }
          this.CalculateTotal();


        })
        .catch(err => {
          this.$vs.loading.close();
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
    }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }

  .con-select .vs-select {
    width: 100%
  }
}

.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}

#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

  }
}</style>
